import { useEffect, useEffectEvent, useMemo } from 'react';
import { useQuery } from '@apollo/client/react';
import { ErrorLike } from '@apollo/client';

import { TrainingLinkedGroupsDocument } from 'graphql/types';
import { useApolloError } from 'common/hooks/useApolloError';

interface IUseTrainingLinkedGroupsOptions {
    trainingId: string;
}

export const useTrainingLinkedGroups = ({
    trainingId,
}: IUseTrainingLinkedGroupsOptions) => {
    const { showApolloError } = useApolloError();

    const { data, loading, error } = useQuery(TrainingLinkedGroupsDocument, {
        variables: { id: trainingId },
    });

    const onError = useEffectEvent((error: ErrorLike) => {
        showApolloError(error);
    });

    useEffect(() => {
        if (error) {
            onError(error);
        }
    }, [error]);

    const linkedGroups = useMemo(
        () => data?.training?.groups || [],
        [data?.training?.groups]
    );

    const linkedGroupIds = useMemo(
        () => linkedGroups.map((group) => group.id),
        [linkedGroups]
    );

    return { linkedGroups, linkedGroupIds, loading };
};
